<template>
  <el-dialog class='dialog-mobile' title="修改密码" :visible.sync="dialogVisible" width="40%">
    <el-form ref="formPw" :model="formData" label-width="180px" :rules="rules">

      <el-form-item label="请输入账号原密码" prop="oldPassword">
        <el-input type="password" v-model="formData.oldPassword" placeholder="请输入原密码"></el-input>
      </el-form-item>

      <el-form-item label="请输入账号新密码" prop="newPassword">
        <el-input type="password" v-model="formData.newPassword" placeholder="6-20位，包含字母和数字"></el-input>
      </el-form-item>

      <el-form-item label="请输入确认账号新密码" prop="rePassword">
        <el-input type="password" v-model="formData.rePassword" placeholder="请再次输入新密码"></el-input>
      </el-form-item>

    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="confirmHandle">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import CryptoJS from 'crypto-js'; // 1. 引入加密库
import { changePw } from '@/api';

// 2. AES 密钥 (必须与注册/登录/后端完全一致)
const AES_KEY = "xVjzymyDzUN8dk0W";

export default {
  components: {},
  data() {
    // 3. 定义密码复杂度校验
    const validatePasswordComplexity = (rule, value, callback) => {
      const reg = /^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9._~!@#$^&*]{6,20}$/;
      if (!value) {
        callback(new Error('请输入新密码'));
      } else if (!reg.test(value)) {
        callback(new Error('密码需包含字母和数字，长度6-20位'));
      } else {
        if (this.formData.rePassword) {
          this.$refs.formPw.validateField('rePassword');
        }
        callback();
      }
    };

    // 4. 定义确认密码校验
    const validateConfirmPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请再次输入新密码'));
      } else if (value !== this.formData.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };

    return {
      dialogVisible: false,
      formData: {
        oldPassword: '',
        newPassword: '',
        rePassword: ''
      },
      rules: {
        oldPassword: [
          { required: true, message: '请输入账号原密码', trigger: 'blur' },
        ],
        newPassword: [
          { required: true, validator: validatePasswordComplexity, trigger: 'blur' },
        ],
        rePassword: [
          { required: true, validator: validateConfirmPassword, trigger: 'blur' }
        ],
      },
    };
  },
  methods: {
    show(v) {
      this.dialogVisible = true;
      // 打开时清空表单
      this.$nextTick(() => {
        if(this.$refs['formPw']) this.$refs['formPw'].resetFields();
      });
    },

    // AES 加密方法
    encryptByAES(message) {
      const key = CryptoJS.enc.Utf8.parse(AES_KEY);
      const srcs = CryptoJS.enc.Utf8.parse(message);
      const encrypted = CryptoJS.AES.encrypt(srcs, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    },

    confirmHandle() {
      this.$refs['formPw'].validate((valid) => {
        if (valid) {
          // 5. 加密三个密码字段
          const reqData = {
            oldPassword: this.encryptByAES(this.formData.oldPassword),
            newPassword: this.encryptByAES(this.formData.newPassword),
            rePassword: this.encryptByAES(this.formData.rePassword)
          };

          changePw(reqData).then(res => {
            this.$message({
              message: '修改成功，请重新登录',
              type: 'success'
            });
            this.dialogVisible = false;
            // 清除 Token 并跳转登录
            this.$store.dispatch('setToken', undefined);
            this.$router.replace('/login');
          })
        }
      })
    }
  }
}
</script>

<style lang='scss'>
// 样式保持不变
.dialog-mobile {
  .el-button {
    width: 120px;
    height: 40px;
    &:hover {
      background-color: $red;
      border-color: $red;
      color: #fff;
    }
  }
  .el-button--primary {
    background-color: $red;
    border-color: $red;
  }
  .el-input {
    width: 230px;
    .el-input__inner {
      width: 280px;
      height: 40px;
      border: 1px solid #efefef !important;
      border-radius: 3px;
    }
  }
}
</style>
